import * as React from "react";
import { SVGProps } from "react";

const IndividualPayoutsIconSidebar = (props: SVGProps<any>): JSX.Element => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={props.width || 22}
      height={props.height || 22}
      fill='none'
      viewBox='0 0 32 32'
      className={`dynamic-icon ${props.className}`}
      {...props}
    >
    <path
      stroke="#9395A1"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M8 24 24 8M11 8h13v13"
    />
  </svg>
);

export default IndividualPayoutsIconSidebar;

